import { styled } from 'parkdepot-shared/theme'

export const Container = styled('section', ({ $theme }) => ({
    width: '100%'
}))

export const InformationTitle = styled('div', ({ $theme }) => ({
    ...$theme.typography.LabelLarge,
    fontWeight: 700,
    marginBottom: '1.2rem'
}))

export const SectionTitle = styled('h2', ({ $theme }) => ({
    ...$theme.typography.ParagraphMedium,
    fontWeight: 600,
    color: '#000',
    lineHeight: '24px',
    margin: 0
}))

export const LotAddress = styled('p', ({ $theme }) => ({
    ...$theme.typography.ParagraphMedium,
    lineHeight: '24px',
    fontWeight: 400,
    margin: 0
}))

export const SectionWrapper = styled('section', ({ $theme }) => ({
    display: 'flex',
    margin: '1.4rem 0 1.2rem',
    gap: '1rem'
}))

export const Description = styled('p', ({ $theme }) => ({
    ...$theme.typography.ParagraphMedium,
    whiteSpace: 'pre-line',
    margin: 0
}))
